import React, { useRef, useState } from "react";
import DevidText from "../../../../Components/DevidText/DevidText";
import FormButton from "../../../../Components/Elements/FormButton";
import LabelInput from "../../../../Components/Elements/LabelInput";

function SearchForm({ onFilterChange }) {
  const data = {
    Title: "SEARCH OUR RESIDENTIAL & COMMERCIAL REAL ESTATE LISTINGS",
    details:
      "When it comes to looking for the right place, you can trust Home Realtors can deliver the place you want.Whether you're in the market for residential or commercial real estate listings, our local realtors do their best to show a variety of listing that meets your needs and wants. Be sure to browse our current offerings. For years, our local real estate team has continued to assist clients throughout Big Spring, TX, Midland, TX, Colorado City, TX, Lamesa, TX, and all the surrounding communities. We've managed to streamline the standard real estate process, making it easier than ever to track down the perfect property! If you're ready to start looking with a trustworthy and friendly staff of professionals, call us today. We are always ready to help make the process of buying your next home or selling your home as smooth and stress-free as possible",
  };
  
  const cols = useRef("col-lg-3 col-md-4 col-sm-12");
  
  const [filters, setFilters] = useState({
    unitType: "",
    unitStatus: "",
    minPrice: "",
    maxPrice: "",
    minBUA: "",
    maxBUA: "",
    minBedrooms: "",
    maxBedrooms: "",
    buildingNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFilters = { ...filters, [name]: value };
    setFilters(updatedFilters);
    if (onFilterChange) {
      onFilterChange(updatedFilters);
    }
  };

  const handleReset = () => {
    const resetFilters = {
      unitType: "",
      unitStatus: "",
      minPrice: "",
      maxPrice: "",
      minBUA: "",
      maxBUA: "",
      minBedrooms: "",
      maxBedrooms: "",
      buildingNumber: "",
    };
    setFilters(resetFilters);
    if (onFilterChange) {
      onFilterChange(resetFilters);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onFilterChange) {
      onFilterChange(filters);
    }
  };

  return (
    <div className="search-form-container">
      <div className="title-MakeOurNumbers">
        <DevidText text={data.Title} />
      </div>
      <div className="paragraph-search-form">{data.details}</div>

      <form className="row search-form-form client-form" onSubmit={handleSubmit}>
        <div className={cols.current}>
          <LabelInput
            Label="Unit Type"
            type="select"
            name="unitType"
            value={filters.unitType}
            onChange={handleChange}
            options={[
              { value: "", label: "All Types" },
              { value: "Office", label: "Office" },
              { value: "Clinic", label: "Clinic" },
              { value: "Shop", label: "Shop" }
            ]}
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Status"
            type="select"
            name="unitStatus"
            value={filters.unitStatus}
            onChange={handleChange}
            options={[
              { value: "", label: "All Statuses" },
              { value: "Available", label: "Available" },
              { value: "Reserved", label: "Reserved" },
              { value: "Sold", label: "Sold" }
            ]}
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Building Number"
            type="text"
            name="buildingNumber"
            value={filters.buildingNumber}
            onChange={handleChange}
            placeholder="Building #"
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Min Price"
            type="number"
            name="minPrice"
            value={filters.minPrice}
            onChange={handleChange}
            placeholder="Min Price"
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Max Price"
            type="number"
            name="maxPrice"
            value={filters.maxPrice}
            onChange={handleChange}
            placeholder="Max Price"
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Min BUA (m²)"
            type="number"
            name="minBUA"
            value={filters.minBUA}
            onChange={handleChange}
            placeholder="Min BUA"
          />
        </div>

        <div className={cols.current}>
          <LabelInput
            Label="Max BUA (m²)"
            type="number"
            name="maxBUA"
            value={filters.maxBUA}
            onChange={handleChange}
            placeholder="Max BUA"
          />
        </div>

        {/* <div className={cols.current}>
          <LabelInput
            Label="Min Bedrooms"
            type="number"
            name="minBedrooms"
            value={filters.minBedrooms}
            onChange={handleChange}
            placeholder="Min Bedrooms"
          />
        </div> */}

        {/* <div className={cols.current}>
          <LabelInput
            Label="Max Bedrooms"
            type="number"
            name="maxBedrooms"
            value={filters.maxBedrooms}
            onChange={handleChange}
            placeholder="Max Bedrooms"
          />
        </div> */}

        <div className="col-12" style={{ margin: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
        
          <FormButton Label="Search" type="submit"  />
          <FormButton Label="Reset" type="button" onClick={handleReset}  />
        </div>
      </form>
    </div>
  );
}

export default SearchForm;
